import { RefObject, createContext } from 'react'

export const FormManagerContext = createContext<{
  register: (name: string, ref: RefObject<HTMLDivElement>) => void
}>({
  register: () => undefined,
})
export * from './FormManager'
export * from './Fields'
